import { createStore, useStore } from 'zustand';
import {
  getUserRewardStatus,
  type UserRewardStatus,
} from '../services/lottery';
import { WalletBase } from '@/types';

type UserLotteryStatusStoreState = {
  data: UserRewardStatus | null;
  isLoading: boolean;
  error: Error | null;
  hasAttempted: boolean;
};

type UserLotteryStatusStoreAction = {
  getUserRewardStatus: (
    wallet: WalletBase,
    force?: boolean
  ) => Promise<UserRewardStatus>;
  reset: () => void;
};

type UserLotteryStatusStore = UserLotteryStatusStoreState &
  UserLotteryStatusStoreAction;

const UserLotteryStore = createStore<UserLotteryStatusStore>((set, get) => ({
  data: null,
  isLoading: false,
  error: null,
  hasAttempted: false,
  getUserRewardStatus: async (wallet, force = false) => {
    if (!force && get().hasAttempted) {
      // TODO 确认是否还需要返回数据
      return Promise.resolve(get().data);
    }

    // console.log('%cAPI got called', 'color: red; font-size: 14px');

    set({ isLoading: true, error: null });
    try {
      const response = await getUserRewardStatus(wallet);
      if (response.success) {
        set({ data: response.result, error: null });
        // TODO 确认是否还需要返回数据
        return response.result;
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      set({ error: error as Error });
    } finally {
      set({ isLoading: false, hasAttempted: true });
    }
  },
  reset: () => {
    set({ data: null, error: null, hasAttempted: false });
  },
}));

export const userLotteryStore = UserLotteryStore;
export const useUserLotteryStore = () => useStore(UserLotteryStore);
